// react
import { lazy } from "react";
// lazy loading pages
const OrdersDashboard = lazy(() =>
  import("../pages/ordersDashboard/OrdersDashboard")
);
const ParentOrders = lazy(() => import("../pages/parentOrders/ParentOrders"));
const EditOrder = lazy(() => import("../pages/editOrder/EditOrder"));
const OrderProfile = lazy(() => import("../pages/orderProfile/OrderProfile"));
const ParentOrderProfile = lazy(() =>
  import("../pages/orderProfile/ParentOrderProfile")
);
const OrderPricingPage = lazy(() =>
  import("../pages/orderPricingPage/OrderPricingPage")
);
const OpForm = lazy(() => import("../pages/opForm/OpForm"));
const VoiceOrdersDashboard = lazy(() =>
  import("../pages/voiceNotesOrdersDashboard/VoiceNotesOrdersDashboard")
);
/* OPERATIONS */
const CourierAssignmentAcceptOrders = lazy(() =>
  import("../pages/CourierAssignment/CourierAssignmentAcceptOrders")
);
const CourierAssignment = lazy(() =>
  import("../pages/CourierAssignment/CourierAssignment")
);
const ReallocationGroups = lazy(() =>
  import("../pages/reallocationGroups/ReallocationGroups")
);
const AvailableCouriers = lazy(() =>
  import("../pages/availableCouriers/AvailableCouriers")
);
const Polygons = lazy(() => import("../pages/Polygons/Polygons"));
const PolygonGroups = lazy(() =>
  import("../pages/PolygonGroups/PolygonGroups")
);
const AddPolygons = lazy(() => import("../pages/Polygons/PolygonsForm"));
const Vehicles = lazy(() => import("../pages/vehicles/Vehicles"));
const CourierAssignmentTransferOrder = lazy(() =>
  import(
    "../pages/courierAssignmentTransferOrders/CourierAssignmentTransferOrders"
  )
);
const PendingCourierDeficits = lazy(() =>
  import("../pages/pendingCourierDeficits/PendingCourierDeficits")
);
const CourierTasks = lazy(() => import("../pages/courierTasks/CourierTasks"));
const Couriers = lazy(() => import("../pages/Couriers/Couriers"));
const CreateCourier = lazy(() => import("../pages/Couriers/CreateCourier"));
const EditCourier = lazy(() => import("../pages/Couriers/EditCourier"));
const SalesUserDashboard = lazy(() =>
  import("../pages/salesUserDashboard/SalesUserDashboard")
);
const NonDeliveryDates = lazy(() =>
  import("../pages/nonDeliveryDates/NonDeliveryDates")
);
const ExpressHours = lazy(() => import("../pages/expressHours/ExpressHours"));
const WarehouseZones = lazy(() => import("../pages/warehouseZones/WarehouseZones"));
/* QUALITY */
const ReviewOrders = lazy(() =>
  import("../pages/Quality/ReviewOrders/ReviewOrders")
);
const Tickets = lazy(() => import("../pages/Quality/Tickets/Tickets"));
const Returns = lazy(() => import("../pages/Quality/Returns/Returns"));
const ReturnTickets = lazy(() =>
  import("../pages/Quality/ReturnTickets/ReturnTickets")
);
const NeedInvestigation = lazy(() =>
  import("../pages/Quality/NeedInvestigation/NeedInvestigation")
);
const VoiceComplaints = lazy(() =>
  import("../pages/Quality/VoiceComplaints/VoiceComplaints")
);
const Reasons = lazy(() => import("../pages/reasons/Reasons"));
const NewReason = lazy(() => import("../pages/newReason/NewReason"));
const EditReason = lazy(() => import("../pages/editReason/EditReason"));
/* END QUALITY PAGES */
const InventoryDashboard = lazy(() =>
  import("../pages/InventoryDashboard/InventoryDashboard")
);
const Consignment = lazy(() => import("../pages/Consignment/Consignment"));
const ConsignmentCustomerReturns = lazy(() =>
  import("../pages/ConsignmentCustomerReturns/ConsignmentCustomerReturns")
);
const ConsignmentReturns = lazy(() =>
  import("../pages/ConsignmentReturns/ConsignmentReturns")
);
const CommercialInventoryDashboard = lazy(() =>
  import("../pages/InventoryDashboard/CommercialInventoryDashboard")
);
const PurchaseOrders = lazy(() =>
  import("../pages/PurchaseOrdersDashboard/PurchaseOrders")
);
const PurchaseOrderDetails = lazy(() =>
  import("../pages/purchaseOrderDetails/PurchaseOrderDetails")
);
const ReceiveFormDetails = lazy(() =>
  import("../pages/receiveFormDetails/ReceiveFormDetails")
);
const RequestPurchaseOrder = lazy(() =>
  import("../pages/requestPurchaseOrder/RequestPurchaseOrder")
);
const ReturnOrdersDashboard = lazy(() =>
  import("../pages/ReturnOrdersDashboard/ReturnOrdersDashboard")
);
const SalesOrdersDashboard = lazy(() =>
  import("../pages/SalesOrdersDashboard/SalesOrdersDashboard")
);
const MechanicsDashboard = lazy(() =>
  import("../pages/MechanicsDashboard/MechanicsDashboard")
);
const MechanicCategory = lazy(() =>
  import("../pages/systemData/MechanicCategory")
);
const MechanicSegment = lazy(() =>
  import("../pages/systemData/MechanicSegment")
);
const MechanicSize = lazy(() => import("../pages/systemData/MechanicSize"));

const TelesalesRunsheet = lazy(() =>
  import("../pages/telesalesRunsheet/TelesalesRunsheet")
);
const MechanicDetailsPage = lazy(() =>
  import("../pages/mechanicDetailsPage/MechanicDetailsPage")
);
const TrackingSalesVisits = lazy(() =>
  import("../pages/trackingSalesVisits/TrackingSalesVisits")
);
const SalesAgentsPage = lazy(() => import("../pages/Sales/SalesAgentsPage"));
const CreateSalesAgentPage = lazy(() =>
  import("../pages/Sales/CreateSalesAgentPage")
);
const EditSalesAgentPage = lazy(() =>
  import("../pages/Sales/EditSalesAgentPage")
);
const CarsDashboard = lazy(() =>
  import("../pages/CarsDashboard/CarsDashboard")
);
const CreateCar = lazy(() => import("../pages/createCar/CreateCar"));
const EditCar = lazy(() => import("../pages/EditCar/EditCar"));
const CreateCarBrand = lazy(() => import("../pages/carOptions/CreateCarBrand"));
const EditCarBrand = lazy(() => import("../pages/carOptions/EditCarBrand"));
const CreateCarModel = lazy(() => import("../pages/carOptions/CreateCarModel"));
const EditCarModel = lazy(() => import("../pages/carOptions/EditCarModel"));
const CreateCarEngine = lazy(() =>
  import("../pages/carOptions/CreateCarEngine")
);
const SuppliersDashboard = lazy(() =>
  import("../pages/SuppliersDashboard/SuppliersDashboard")
);
const AddNewSupplier = lazy(() =>
  import("../pages/SuppliersDashboard/AddNewSupplier/AddNewSupplier")
);
const EditSupplier = lazy(() =>
  import("../pages/SuppliersDashboard/EditSupplier/EditSupplier")
);
const SupplierShop = lazy(() =>
  import("../pages/SuppliersDashboard/SupplierShop/SupplierShop")
);
const SupplierDetailsPage = lazy(() =>
  import("../pages/SuppliersDashboard/SupplierDetailsPage/SupplierDetailsPage")
);
const NotificationService = lazy(() =>
  import("../pages/notificationCenter/NotificationService/NotificationService")
);
const ScheduledNotifications = lazy(() =>
  import(
    "../pages/notificationCenter/scheduledNotifications/ScheduledNotifications"
  )
);
const CreateScheduledNotification = lazy(() =>
  import(
    "../pages/notificationCenter/scheduledNotifications/CreateScheduledNotification"
  )
);
const SuppliersNotifications = lazy(() =>
  import(
    "../pages/notificationCenter/SuppliersNotifications/SuppliersNotifications"
  )
);
const MechanicsNotifications = lazy(() =>
  import(
    "../pages/notificationCenter/MechanicsNotifications/MechanicsNotifications"
  )
);
const PricingHistoryDashboard = lazy(() =>
  import("../pages/pricingHistoryDashboard/PricingHistoryDashboard")
);
const SupplierSkusPrices = lazy(() =>
  import("../pages/SupplierSkusPrices/SupplierSkusPrices")
);
const SkusDashboard = lazy(() =>
  import("../pages/skusDashboard/SkusDashboard")
);
const SkusEagleEye = lazy(() => import("../pages/skusEagleEye/SkusEagleEye"));
const AddNewSku = lazy(() => import("../pages/createSku/CreateSku"));
const EditSku = lazy(() => import("../pages/editSku/EditSku"));
const ReplicateSku = lazy(() =>
  import("../pages/sku/skuReplicate/ReplicateSku")
);
const SkuDetailsPage = lazy(() => import("../pages/skuDetails/SkuDetailsPage"));
const EditSkuBrand = lazy(() => import("../pages/sku/skuBrand/EditSkuBrand"));
const EditSkuName = lazy(() => import("../pages/sku/skuName/EditSkuName"));
const CreateSkuCategory = lazy(() =>
  import("../pages/sku/skuCategory/CreateSkuCategory")
);
const EditSkuCategory = lazy(() =>
  import("../pages/sku/skuCategory/EditSkuCategory")
);
const CreateSkuSubCategory = lazy(() =>
  import("../pages/sku/skuSubCategory/CreateSkuSubCategory")
);
const EditSkuSubCategory = lazy(() =>
  import("../pages/sku/skuSubCategory/EditSkuSubCategory")
);
const CreateSkuOrigin = lazy(() =>
  import("../pages/sku/skuOrigin/CreateSkuOrigin")
);
const EditSkuOrigin = lazy(() =>
  import("../pages/sku/skuOrigin/EditSkuOrigin")
);
const SkusPending = lazy(() => import("../pages/skusPending/SkusPending"));
const SkusReturnPending = lazy(() =>
  import("../pages/skusReturnPending/SkusReturnPending")
);
const BrandFamiliesDashboard = lazy(() =>
  import("../pages/brandFamiliesDashboard/BrandFamiliesDashboard")
);
const NewBrandFamily = lazy(() =>
  import("../pages/newBrandFamily/NewBrandFamily")
);
const EditBrandFamily = lazy(() =>
  import("../pages/editBrandFamily/EditBrandFamily")
);
const SupplierPendingSkus = lazy(() =>
  import("../pages/SupplierPendingSkus/SupplierPendingSkus")
);
const WrongFitmentTickets = lazy(() =>
  import("../pages/WrongFitmentTickets/WrongFitmentTickets")
);
const Banners = lazy(() => import("../pages/banners/Banners"));
const NewBanner = lazy(() => import("../pages/newBanner/NewBanner"));
const EditBanner = lazy(() => import("../pages/editBanner/EditBanner"));
const ReturnedItemsDashboard = lazy(() =>
  import("../pages/returnedItemsDashboard/ReturnedItemsDashboard")
);
const FailedReturnOrdersDashboard = lazy(() =>
  import("../pages/failedReturnOrdersDashboard/FailedReturnOrdersDashboard")
);
const VendorSupport = lazy(() =>
  import("../pages/vendorSupport/vendorSupportPricing/VendorSupport")
);
const AcceptedOrdersDashboard = lazy(() =>
  import(
    "../pages/vendorSupport/AcceptedOrdersDashboard/AcceptedOrdersDashboard"
  )
);
const NeedSupportDashboard = lazy(() =>
  import("../pages/vendorSupport/NeedSupportDashboard/NeedSupportDashboard")
);
const TowerHistory = lazy(() =>
  import("../pages/vendorSupport/TowerHistory/TowerHistory")
);
const ChatRooms = lazy(() => import("../pages/ChatRooms/ChatRooms"));
const StockReturns = lazy(() => import("../pages/StockReturns/StockReturns"));
const DeepLinks = lazy(() => import("../pages/DeepLinks/DeepLinks"));
const NewStockReturnOrderPage = lazy(() =>
  import("../pages/StockReturns/NewStockReturnOrderPage")
);
const EditStockReturnOrderPage = lazy(() =>
  import("../pages/StockReturns/EditStockReturnOrderPage")
);
const Taxes = lazy(() => import("../pages/Taxes/Taxes"));
const InstaPartsTaxes = lazy(() => import("../pages/Taxes/InstaPartsTaxes"));
const CourierSupplierHub = lazy(() =>
  import("../pages/CourierSupplierHub/CourierSupplierHub")
);
const InventoryTransferOrders = lazy(() =>
  import("../pages/InventoryTransferOrders/InventoryTransferOrders")
);
const NewTransferOrder = lazy(() =>
  import("../pages/InventoryTransferOrders/NewTransferOrder/NewTransferOrder")
);
const TransferOrderDetails = lazy(() =>
  import(
    "../pages/InventoryTransferOrders/TransferOrderDetails/TransferOrderDetails"
  )
);
const SkusMissingCbm = lazy(() =>
  import("../pages/skusMissingCbm/SkusMissingCbm")
);
const CreateSkuName = lazy(() => import("../pages/sku/skuName/CreateSkuName"));
const CreateSkuBrand = lazy(() =>
  import("../pages/sku/skuBrand/CreateSkuBrand")
);
const RepricingOrders = lazy(() =>
  import("../pages/RepricingOrders/RepricingOrders")
);
const OrdersFromVoiceNotes = lazy(() =>
  import("../pages/ordersFromVoiceNotes/OrdersFromVoiceNotes")
);
const MechanicNeedSupport = lazy(() =>
  import("../pages/mechanicNeedSupport/MechanicNeedSupport")
);
const MechanicAppStockOrders = lazy(() =>
  import("../pages/mechanicAppStockOrders/MechanicAppStockOrders")
);
const PromotionEngine = lazy(() =>
  import("../pages/promotionEngine/PromotionEngine")
);
const CreatePromotion = lazy(() =>
  import("../pages/promotionEngine/createPromotion/CreatePromotion")
);
const Bundle = lazy(() => import("../pages/bundle/Bundle"));
const CreateBundle = lazy(() =>
  import("../pages/bundle/createBundle/CreateBundle")
);
const MechanicAppPricingOrders = lazy(() =>
  import("../pages/mechanicAppPricingOrders/MechanicAppPricingOrders")
);
const SalesTracking = lazy(() =>
  import("../pages/salesTracking/SalesTracking")
);
const CourierWallet = lazy(() =>
  import("../pages/courierWallet/CourierWallet")
);
const MechanicWallet = lazy(() =>
  import("../pages/mechanicWallet/MechanicWallet")
);
const SupplierWallet = lazy(() =>
  import("../pages/supplierWallet/SupplierWallet")
);
const SupplierHubWallet = lazy(() =>
  import("../pages/supplierHubWallet/SupplierHubWallet")
);
const UserManagement = lazy(() =>
  import("../pages/userManagement/UserManagement")
);
const MechanicGrouping = lazy(() =>
  import("../pages/mechanicGrouping/MechanicGrouping")
);
const RepricingInventorySkus = lazy(() =>
  import("../pages/repricingInventorySkus/RepricingInventorySkus")
);
const RepricingRequests = lazy(() =>
  import("../pages/RepricingRequests/RepricingRequests")
);
const SubCategoriesMargin = lazy(() =>
  import("../pages/subCategoriesMargin/SubCategoriesMargin")
);
const CommercialMapping = lazy(() =>
  import("../pages/commercialMapping/CommercialMapping")
);

const MtorAiMapping = lazy(() =>
  import("../pages/mtorAiMapping/MtorAiMapping")
);
const UpdateMtorAiMapping = lazy(() =>
  import("../pages/mtorAiMapping/Components/UpdateMtorAiMapping")
);

const InstaMartUsers = lazy(() =>
  import("../pages/InstaParts/InstaPartsUsers/InstaMartUsers")
);

const InstaPartsPolygons = lazy(() =>
  import("../pages/InstaParts/Polygons/InstaPartsPolygons")
);

const InstaPartsReturnOrders = lazy(() =>
  import("../pages/PartSmart/ReturnOrders/InstaPartsReturnOrders")
);
const InstaPartsStockReturns = lazy(() =>
  import("../pages/PartSmart/StockReturns/InstaPartsStockReturns")
);
const Pos = lazy(() => import("../pages/PartSmart/POs/POs"));
const Sos = lazy(() => import("../pages/PartSmart/SOs/SOs"));

const Assets = lazy(() => import("../pages/IT/Assets"));
const AssetLogs = lazy(() => import("../pages/IT/AssetLogs"));
const Employees = lazy(() => import("../pages/IT/Employees"));
const Roles = lazy(() => import("../pages/roles/Roles"));
const AddRole = lazy(() => import("../pages/addRole/AddRole"));
const EditRole = lazy(() => import("../pages/editRole/EditRole"));
const Gearbox = lazy(() => import("../pages/Gearbox/Gearbox"));
const MechanicCompensations = lazy(() =>
  import("../pages/mechanicCompensations/MechanicCompensations")
);
const RequestedProducts = lazy(() =>
  import("../pages/requestedProducts/RequestedProducts")
);
const RequestsDetails = lazy(() =>
  import("../pages/requestsDetails/RequestsDetails")
);
const IntersectionIds = lazy(() =>
  import("../pages/intersectionIds/IntersectionIds")
);
const SkusTargets = lazy(() => import("../pages/SkusTargets/SkusTargets"));
const IntersectionMatrix = lazy(() =>
  import("../pages/intersectionMatrix/IntersectionMatrix")
);

const ReceiveConsignmentOrder = lazy(() =>
  import("../pages/ReceiveConsignmentOrder/ReceiveConsignmentOrder")
);

const ViewConsignmentOrder = lazy(() =>
  import("../pages/ViewConsignmentOrder/ViewConsignmentOrder")
);

const ViewConsignmentReturnOrder = lazy(() =>
  import("../pages/ViewConsignmentReturnOrder/ViewConsignmentReturnOrder")
);

const Pickers = lazy(() => import("../pages/pickers/Pickers"));
const CreatePicker = lazy(() => import("../pages/pickers/CreatePicker"));
const EditPicker = lazy(() => import("../pages/pickers/EditPicker"));
const MissingTransactions = lazy(() =>
  import("../pages/missingTransactions/MissingTransactions")
);
const RunsheetsDashboard = lazy(() =>
  import("../pages/runsheetsDashboard/RunsheetsDashboard")
);
const PickerTab = lazy(() => import("../pages/pickerTab/PickerTab"));

const PickingSkuModal = lazy(() =>
  import("../pages/pickerTab/PickingSkuModal")
);

const PickingOrderModal = lazy(() =>
  import("../pages/pickerTab/PickingOrderModal")
);

export {
  OrdersDashboard,
  ParentOrders,
  EditOrder,
  OrderProfile,
  ParentOrderProfile,
  OrderPricingPage,
  OpForm,
  VoiceOrdersDashboard,
  CourierAssignmentAcceptOrders,
  CourierAssignment,
  ReallocationGroups,
  AvailableCouriers,
  NonDeliveryDates,
  ExpressHours,
  WarehouseZones,
  Polygons,
  PolygonGroups,
  Vehicles,
  CourierAssignmentTransferOrder,
  PendingCourierDeficits,
  CourierTasks,
  Couriers,
  CreateCourier,
  EditCourier,
  SalesUserDashboard,
  SalesAgentsPage,
  CreateSalesAgentPage,
  EditSalesAgentPage,
  ReviewOrders,
  Tickets,
  ReturnTickets,
  Returns,
  NeedInvestigation,
  VoiceComplaints,
  InventoryDashboard,
  Consignment,
  ConsignmentCustomerReturns,
  ConsignmentReturns,
  CommercialInventoryDashboard,
  PurchaseOrders,
  PurchaseOrderDetails,
  ReceiveFormDetails,
  RequestPurchaseOrder,
  ReturnOrdersDashboard,
  SalesOrdersDashboard,
  MechanicsDashboard,
  MechanicCategory,
  MechanicSegment,
  MechanicSize,
  TelesalesRunsheet,
  MechanicDetailsPage,
  TrackingSalesVisits,
  CarsDashboard,
  CreateCar,
  EditCar,
  CreateCarBrand,
  EditCarBrand,
  CreateCarModel,
  EditCarModel,
  CreateCarEngine,
  SuppliersDashboard,
  AddNewSupplier,
  EditSupplier,
  SupplierShop,
  SupplierDetailsPage,
  NotificationService,
  ScheduledNotifications,
  CreateScheduledNotification,
  SuppliersNotifications,
  MechanicsNotifications,
  PricingHistoryDashboard,
  SupplierSkusPrices,
  SkusDashboard,
  SkusEagleEye,
  AddNewSku,
  EditSku,
  ReplicateSku,
  SkuDetailsPage,
  EditSkuBrand,
  EditSkuName,
  SkusPending,
  SkusReturnPending,
  BrandFamiliesDashboard,
  NewBrandFamily,
  EditBrandFamily,
  SupplierPendingSkus,
  WrongFitmentTickets,
  ReturnedItemsDashboard,
  FailedReturnOrdersDashboard,
  VendorSupport,
  AcceptedOrdersDashboard,
  NeedSupportDashboard,
  TowerHistory,
  ChatRooms,
  StockReturns,
  DeepLinks,
  NewStockReturnOrderPage,
  EditStockReturnOrderPage,
  Taxes,
  InstaPartsTaxes,
  CourierSupplierHub,
  InventoryTransferOrders,
  NewTransferOrder,
  TransferOrderDetails,
  SkusMissingCbm,
  CreateSkuName,
  CreateSkuBrand,
  CreateSkuCategory,
  EditSkuCategory,
  CreateSkuSubCategory,
  EditSkuSubCategory,
  CreateSkuOrigin,
  EditSkuOrigin,
  RepricingOrders,
  OrdersFromVoiceNotes,
  MechanicNeedSupport,
  MechanicAppStockOrders,
  PromotionEngine,
  CreatePromotion,
  Bundle,
  CreateBundle,
  MechanicAppPricingOrders,
  SalesTracking,
  CourierWallet,
  MechanicWallet,
  UserManagement,
  SupplierWallet,
  SupplierHubWallet,
  RepricingInventorySkus,
  RepricingRequests,
  SubCategoriesMargin,
  CommercialMapping,
  MtorAiMapping,
  UpdateMtorAiMapping,
  InstaMartUsers,
  InstaPartsPolygons,
  InstaPartsReturnOrders,
  InstaPartsStockReturns,
  Pos,
  Sos,
  Assets,
  AssetLogs,
  Employees,
  Roles,
  AddRole,
  EditRole,
  MechanicGrouping,
  Gearbox,
  AddPolygons,
  Banners,
  NewBanner,
  EditBanner,
  Reasons,
  NewReason,
  EditReason,
  MechanicCompensations,
  RequestedProducts,
  RequestsDetails,
  IntersectionIds,
  SkusTargets,
  IntersectionMatrix,
  ReceiveConsignmentOrder,
  ViewConsignmentOrder,
  ViewConsignmentReturnOrder,
  Pickers,
  CreatePicker,
  EditPicker,
  MissingTransactions,
  RunsheetsDashboard,
  PickerTab,
  PickingSkuModal,
  PickingOrderModal,
};
